/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "workflowdefinitions",
	init: init,
	triggers: triggers,
	listeners: listeners,

	track_definitions: track_definitions,
	_tracking: [],
});

function init() {
	this._tracker = this.dispatcher.createTracker();
	this.push({});
}

function listeners(){
	return {
		"orggroup:updated": handle_org_group_update
	};
}

function triggers() {
	return {
		"track": track
	};
}

function track(data) {
	var workflows = data.definitions;

	var newWorkflows = workflows.filter(function (workflow) {
		return this._tracking.indexOf(workflow) === -1;
	}, this);

	if (!newWorkflows.length) return;

	var deDuped = newWorkflows.reduce(function (result, item) {
		if (result.indexOf(item) === -1)
			return result.concat(item);
		return result;
	}, []);

	this._tracking = this._tracking.concat(deDuped);

	deDuped.map(loadDefinition, this);
}

function loadDefinition(definition) {
	this.api
		.workflow.fullDefinition(definition)
		.then(handle_loaded.bind(this, definition))
		.catch(console.error.bind(console));
}

function handle_loaded(id, definition) {
	var update = {};
	update[id] = definition;

	this.extend(update);
}

function track_definitions(){
	var tracker = this._tracker;
	var orgGroup = this._orgGroup;
	if(!orgGroup) return;

	tracker.off();
	tracker.on("mqtt:orggroup/" + orgGroup + "/workflow/definitions/updated", update_workflow_definition.bind(this));
}

function update_workflow_definition(data){
	var updateId = data._id;
	var currentDefinitions = this.data;
	var toUpdate = currentDefinitions[updateId];
	if(!toUpdate) return;

	var update = {};
	update[updateId] = xtend(toUpdate, data);

	this.extend(update);
}

function handle_org_group_update(data){
	this._orgGroup = data;
	this.track_definitions();
}
